import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ARCHITECT_HOME, shouldRedirectArchitect } from '../lib/roleAccess';

export const ProtectedRoute = ({
  children,
  requiredPermission = null,
  requiredAnyPermission = null,
  allowedRoles = [],
  architectWorkspace = false,
}) => {
  const { user, loading, hasPermission, hasAnyPermission } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (shouldRedirectArchitect(user, location.pathname)) {
    return <Navigate to={ARCHITECT_HOME} replace />;
  }

  const architectWorkspaceAccess = architectWorkspace && (user.role === 'architect' || user.role === 'architect_manager');

  if (requiredPermission && !architectWorkspaceAccess && !hasPermission(requiredPermission)) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (requiredAnyPermission && !architectWorkspaceAccess && !hasAnyPermission(requiredAnyPermission)) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};
